const systemAvatar = '//storage.googleapis.com/locambio-admin/logos/isologo0.jpg';

export default systemAvatar;